/** Thrown when a document context hook is used outside QuoteDocumentRenderer. */
export class QuoteDocumentContextError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "QuoteDocumentContextError";
  }
}

/** Thrown when an fp-image asset upload fails in the document editor. */
export class ImageUploadError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ImageUploadError";
  }
}

/** Thrown when resolving an fp-image asset's file name fails. */
export class AssetNameLookupError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "AssetNameLookupError";
  }
}
